import { Skeleton } from 'antd';

import type { FC } from 'react';

import './LeadListSkeleton.scss';

interface LeadListSkeletonProps {
  rowsCount?: number;
}

const DEFAULT_SKELETON_ROWS_COUNT = 8;

export const LeadListSkeleton: FC<LeadListSkeletonProps> = ({
  rowsCount = DEFAULT_SKELETON_ROWS_COUNT,
}) => (
  <div className="LeadListSkeleton" aria-busy="true" aria-live="polite">
    {Array.from({ length: rowsCount }, (_, index) => (
      <div className="LeadListSkeleton__row" key={index}>
        <Skeleton.Avatar
          className="LeadListSkeleton__avatar"
          active
          size={32}
          shape="circle"
        />
        <div className="LeadListSkeleton__content">
          <Skeleton.Input
            className="LeadListSkeleton__name"
            active
            size="small"
          />
          <Skeleton.Input
            className="LeadListSkeleton__last-message"
            active
            size="small"
          />
        </div>
        <div className="LeadListSkeleton__meta">
          <Skeleton.Input
            className="LeadListSkeleton__time"
            active
            size="small"
          />
        </div>
      </div>
    ))}
  </div>
);
